export const HEADER_HEIGHT_IN_PX = 62;
